import React, {useMemo, useRef} from 'react'
import Modal from "../../../components/Modal";
import {Link, Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import {useAuth} from "../../../providers/AuthProvider";
import AgencyOpportunity from "../../../models/AgencyOpportunity";
import OppRejectionFeedbackModal from "../../talent-opportunities/components/OppRejectionFeedbackModal";
import OppBriefStep from "../../talent-opportunities/OppBriefStep";

const OppReviewBrief = (props) => {

    const {auth} = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const {
        opportunity,
        onUpdate,
        isDisabled,
        changeProps,
        onRequest,
        onAccept,
        onRemoveInterest,
        onShowInterest,
        onReject,
        onWithdrawForAgency
    } = useOpportunity();


    const rejectModal = useRef(null)

    const briefSteps = useMemo(() => opportunity?.projectBriefSteps() || [], [opportunity]);

    const activeStep = useMemo(() => {
        if (!opportunity) {
            return;
        }

        return TB.find(briefSteps, step =>
            TB.includes(location.pathname, TB.slugify(step.sectionTitle))
        );
    }, [location.pathname, briefSteps])
    const activeStepIndex = useMemo(() => {
        return briefSteps.indexOf(activeStep);
    }, [activeStep, location.pathname, briefSteps])

    const prevStep = useMemo(() => {
        return briefSteps[activeStepIndex - 1];
    }, [activeStepIndex, briefSteps])

    const nextStep = useMemo(() => {
        return briefSteps[activeStepIndex + 1];
    }, [activeStepIndex, briefSteps])

    const hasPrevStep = useMemo(() => activeStepIndex > 0, [activeStepIndex]);
    const hasNextStep = useMemo(() => {
        return activeStepIndex < (briefSteps.length - 1)
    }, [activeStepIndex, briefSteps]);

    const goToPrevStep = () => {
        if (!prevStep) {
            return;
        }
        return navigate({pathname: OppBriefStep.pathForOppBrief(opportunity, prevStep)}, {replace: true});
    }

    const goToNextStep = () => {
        if (!nextStep) {
            return;
        }
        return navigate({pathname: OppBriefStep.pathForOppBrief(opportunity, nextStep)}, {replace: true});
    }

    const rejectOpportunity = async () => {
        await rejectModal.current?.showModal();
    }

    const withdrawFromOpportunity = async () => {
        let didWithdraw = await onWithdrawForAgency()
        console.log('withdrawFromOpportunity', didWithdraw)
        if (!didWithdraw) {
            return;
        }
    }

    const removeInterestForOpportunity = async () => {
        let didRemoveInterest = await onRemoveInterest()
        console.log('withdrawFromOpportunity', didRemoveInterest)
        if (!didRemoveInterest) {
            return;
        }
    }


    const alertForMissingSections = async () => {
        return TB.sysAlert('talent.accept_opportunity_brief_required');
    }

    const acceptOpportunity = async () => {
        if (opportunity.isAccepted()) {
            return;
        }

        if (!opportunity.hasAcceptedProjectBriefSections()) {
            return alertForMissingSections();
        }

        // let opportunity = {...opportunity}
        // opportunity.accepted_at = new Date();
        // let opportunity = {...opportunity, accepted_at: new Date()};


        let didUpdate = await onUpdate({accepted_at: new Date()});
    }

    const completeStep = async () => {
        if (opportunity.isInterested() || opportunity?.isAccepted()) {
            console.log("isAccepted")
            return goToNextStep();
        }

        if (opportunity.hasAcceptedProjectBriefSections() && !hasNextStep) {
            console.log("hasAcceptedProjectBriefSections NO next step")
            return acceptOpportunity();
        }

        if (!hasNextStep && !opportunity.hasAcceptedProjectBriefSections()) {
            console.log("!hasAcceptedProjectBriefSections NO next step")
            return alertForMissingSections();
        }
        if (activeStep.isCompleted(opportunity)) {
            return goToNextStep();
        }
    }

    return (
        <div className="supplier-portal-container pb-6 flex-col items-stretch">
        <React.Fragment>
            <div className="talent-portal-page-container talent-opportunity-container px-3">

                <div className="talent-opp-wizard-header talent-opportunity-brief-btns pt-6">

                    <h2>Project Brief</h2>

                    {opportunity.hasUnseenUpdate() && (
                        <p className="opp-unseen-info">
                            <i className="fas fa-exclamation-circle mr-2"/>
                            Updated since last viewed
                        </p>
                    )}

                    {opportunity.can_be_rejected && (
                        <div className="flex flex-row items-center ml-auto">
                            <p>This Opportunity</p>

                            <button className="btn btn-dark"
                                    disabled={!opportunity.can_be_rejected || isDisabled}
                                    onClick={rejectOpportunity}>
                                Pass
                            </button>
                        </div>
                    )}

                    {!opportunity.is_agency_opp && (
                        <div className="flex flex-row items-center ml-auto">
                            <p>This Opportunity</p>
                            <button className="btn btn-dark"
                                    disabled={isDisabled || (opportunity.isInterested() ?
                                        !opportunity.project_position?.has_shown_interest_in_job :
                                        !opportunity.can_be_withdrawn)
                                    }
                                    onClick={opportunity.isInterested() ?
                                        removeInterestForOpportunity :
                                        withdrawFromOpportunity
                                    }>
                                Withdraw Interest
                            </button>
                        </div>
                    )}
                </div>

                <div className="md:flex flex-row justify-center mb-5">

                    <div className='w-full md:w-3/12 brief-steps-menu text-center'
                         style={{maxHeight: briefSteps.length * 54}}>

                        {briefSteps.map((step, i) => {
                            let sectionTitle = opportunity.briefTab(step);

                            let isActive = location.pathname === OppBriefStep.pathForOppBrief(opportunity, step),
                                isComplete = step.isCompleted(opportunity),
                                hasUpdates = opportunity.projectBriefHasUnseenUpdatesAtStep(
                                    step
                                );

                            let icon = 'dot-circle';
                            if (isComplete) {
                                icon = 'check';
                            } else if (isActive) {
                                icon = 'circle';
                            }

                            return (
                                <button key={`sowStep${i}`}
                                        className={TB.mapClass('btn brief-step-btn', {
                                            'active': isActive,
                                            'no-click': isActive || isDisabled
                                        })}
                                        onClick={e => {
                                            if (isActive || isDisabled) {
                                                e.preventDefault()
                                            } else {
                                                navigate({pathname: OppBriefStep.pathForOppBrief(opportunity, step)})
                                            }
                                        }}>
                                    {!opportunity.isInterested() &&
                                        <i className={`fa fa-${icon} mr-3`}/>}
                                    {sectionTitle}
                                    {hasUpdates &&
                                        <i className="fas fa-exclamation-circle opp-unseen-icon ml-3"/>}
                                </button>
                            );
                        })}
                    </div>

                    <div className='md:w-9/12 md:w-full brief-step-section'>

                        <h4 className="panel-header">
                            {opportunity.project.name}
                        </h4>
                        {opportunity.isService() && opportunity.project?.service?.name && (
                            <p className="panel-subheader">
                                Project Type: {opportunity.project.service.name}
                            </p>
                        )}

                        {activeStep && (
                            <h3 className="brief-section-title">
                                {opportunity.briefHeader(activeStep)}
                            </h3>
                        )}
                        {activeStep && (
                            <p className="brief-section-subtitle">
                                {opportunity.briefDescription(activeStep) || ''}
                            </p>
                        )}

                        <Routes>
                            <Route index element={<Navigate
                                to={TB.slugify(opportunity.currentBriefStepNeeded()?.sectionTitle)}
                                replace/>}/>

                            {TB.map(briefSteps, Step => (
                                <Route key={Step.sectionTitle} path={TB.slugify(Step.sectionTitle)}
                                       element={<Step opportunity={opportunity}/>}/>
                            ))}
                            <Route path={'*'} element={<Navigate
                                to={TB.slugify(opportunity.currentBriefStepNeeded()?.sectionTitle)}
                                replace/>}/>

                        </Routes>

                        {activeStep && (
                            <div className="flex items-stretch flex-col">
                                {!opportunity.isInterested() && !opportunity.isAccepted() && (
                                    <div className="form-checkbox mt-3 mb-2">

                                        <input type="checkbox"
                                               disabled={isDisabled}
                                               className="form-check-input"
                                               id={`${activeStep.CompletedField}-checkbox`}
                                               name={`${activeStep.CompletedField}-checkbox`}
                                               onChange={event => {
                                                   let updatedOpp = AgencyOpportunity.make({
                                                           ...opportunity,
                                                           [activeStep.CompletedField]: event.target.checked ? (new Date()) : null
                                                       }
                                                   )
                                                   onRequest(() => changeProps(
                                                       updatedOpp
                                                   ))
                                               }}
                                               checked={activeStep.isCompleted(opportunity) || false}/>

                                        <label className="form-check-label"
                                               htmlFor={`${activeStep.CompletedField}-checkbox`}>
                                            OK, I acknowledge that I have read this page of the brief
                                        </label>


                                    </div>
                                )}
                                <div className="brief-section-btns">
                                    {(opportunity.isAccepted() || opportunity.isInterested()) && hasPrevStep && (
                                        <button
                                            className="btn btn-dark flex items-center justify-center mr-2"
                                            disabled={isDisabled}
                                            onClick={goToPrevStep}>
                                            <i className="fa fa-chevron-left mr-2"/>
                                            <span>Prev</span>
                                        </button>
                                    )}
                                    {hasNextStep ? (
                                        <button
                                            className="btn btn-primary flex items-center justify-center mr-2"
                                            disabled={isDisabled || !activeStep.isCompleted(opportunity)}
                                            onClick={completeStep}>

                                            <span>
                                                Next
                                            </span>

                                            <i className="fa fa-chevron-right ml-2"/>
                                        </button>
                                    ) : (!opportunity.isAccepted() ? (

                                            <button
                                                className="btn btn-primary flex items-center justify-center mr-2"
                                                disabled={isDisabled || (!opportunity.isAccepted() && !activeStep.isCompleted(opportunity))}
                                                onClick={completeStep}>
                                                <span>
                                                    Accept Brief
                                                </span>
                                                <i className="fa fa-chevron-right ml-2"/>

                                            </button>
                                        ) : (
                                            <Link className="btn btn-primary flex items-center justify-center mr-2"
                                                  disabled={isDisabled}
                                                  to={'./../'}>
                                                Go To Matched Talent
                                            </Link>
                                        )
                                    )}

                                </div>

                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Modal
                ref={rejectModal}
                modalClass={"opp-reject-feedback-modal"}
                title="Sorry this project wasn't a fit for you."
                onCloseAction={async () => {
                    console.log('onClose Action')
                }}>

                <OppRejectionFeedbackModal
                    onCancel={() => rejectModal.current?.hideModal(true)}
                    disabled={isDisabled}
                    onSubmit={async (model) => {
                        console.log('onsubmit', model);
                        await rejectModal.current?.hideModal(true);

                        let didReject = await onReject();
                        console.log('REJECTED!', opportunity);
                    }}
                />
            </Modal>
        </React.Fragment>
        </div>
    );
}


export default OppReviewBrief